import React, { useState } from 'react';
import { InputAdornment, IconButton, TextField, TextFieldProps } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface PasswordFieldProps extends Omit<TextFieldProps, 'type'> {
  name: string;
  value?: string;
  label: string;
  error?: boolean;
  helperText?: string | boolean;
  enableViewPassword?: boolean;
  onChange: (e: React.ChangeEvent<any>) => void;
  onBlur: (e: React.FocusEvent<any>) => void;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  name,
  value,
  label,
  error,
  helperText,
  enableViewPassword,
  onChange,
  onBlur,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    if (enableViewPassword) {
      setShowPassword(!showPassword);
    }
  };

  return (
    <TextField
      name={name}
      label={label}
      variant='outlined'
      size='small'
      type={showPassword ? 'text' : 'password'}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end' sx={{ marginRight: '12px' }}>
            <IconButton
              aria-label='alternar visibilidade da senha'
              onClick={handleTogglePasswordVisibility}
              edge='end'
            >
              {enableViewPassword ? (
                showPassword ? (
                  <VisibilityOffIcon />
                ) : (
                  <VisibilityIcon />
                )
              ) : null}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        textTransform: 'uppercase',
        flex: 1,
        '& .MuiInputBase-input': {
          fontFamily: 'Roboto',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0.15px',
          textAlign: 'left',
        },
        '& .MuiInputLabel-root': {
          fontFamily: 'Roboto',
          fontSize: '12px',
          fontWeight: 400,
          letterSpacing: '0.15px',
          textAlign: 'left',
          color: '#00000099',
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: '4px',
          padding: '0px',
          margin: '0px',
          '& fieldset': {
            borderColor: '#0000003B',
          },
          '&:hover fieldset': {
            borderColor: '#0000003B',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#0000003B',
          },
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#00000099',
        },
      }}
      {...rest}
    />
  );
};

export default PasswordField;
